import React, { useState } from "react";
import styles from "./Testimonials.module.css";

const testimonials = [
  { 
    id: 1, 
    initials: "SJ",
    quote: "ToxBox AI Interview Agent cut our scheduling time in half and improved candidate experience significantly.", 
    author: "Sarah J.", 
    role: "Head of Talent, Northwind",
    rating: 5 
  },
  { 
    id: 2, 
    initials: "MC",
    quote: "Objective candidate scoring helped us hire the best talent without bias.", 
    author: "Michael Chen", 
    role: "VP People, Lumen Labs",
    rating: 5 
  },
  { 
    id: 3, 
    initials: "EW",
    quote: "With ToxBox AI, we reduced interview no-shows by 40% and gained deeper insights into candidate performance.", 
    author: "Emma Williams", 
    role: "Recruiting Lead, Vertex",
    rating: 5 
  }
];

const Testimonials = () => {
  const [activeSlide, setActiveSlide] = useState(1);

  return (
    <section className={styles.testimonialsSection}>
      <div className={styles.container}>
        <div className={styles.header}>
          <span className={styles.sectionLabel}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginRight: '6px', verticalAlign: 'middle'}}>
              <path d="M12 22c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10z" fill="currentColor" opacity="0.2"/>
              <path d="M12 8v4l3 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            Testimonials
          </span>
          <h2 className={styles.title}>
            Companies Are <span className={styles.gradientText}>Hiring</span> Smarter and Faster
          </h2>
          <p className={styles.subtitle}>
            Real teams. Real results. Here's what leaders are saying about ToxBox AI.
          </p>
        </div>

        <div className={styles.grid}>
          {testimonials.map((t, idx) => (
            <div 
              key={t.id} 
              className={`${styles.card} ${idx === activeSlide ? styles.activeCard : ""}`}
              onClick={() => setActiveSlide(idx)}
            >
              {/* Initial Badge on Card Top */}
              <div className={`${styles.initialBadge} ${idx === 0 ? styles.blue : idx === 1 ? styles.pink : styles.indigo}`}>
                {t.initials}
              </div>

              <p className={styles.quote}>"{t.quote}"</p>
              
              <div className={styles.divider}></div>

              <div className={styles.footer}>
                <div className={styles.authorMeta}>
                  <h4 className={styles.author}>{t.author}</h4>
                  <p className={styles.role}>{t.role}</p>
                </div>
                <div className={styles.stars}>
                  {[...Array(t.rating)].map((_, i) => (
                    <span key={i} className={styles.star}>★</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Dots */}
        <div className={styles.dots}>
          {testimonials.map((_, index) => (
            <button 
              key={index}
              className={`${styles.dot} ${activeSlide === index ? styles.activeDot : ""}`} 
              onClick={() => setActiveSlide(index)} 
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;